export const getters = {
  userRoleList: (state) => state.userRoleList,
  createUserRoleSuccess: (state) => state.createUserRoleSuccess,
  updateUserRoleSuccess: (state) => state.updateUserRoleSuccess,
  deleteUserRoleSuccess: (state) => state.deleteUserRoleSuccess,
};
